// UploadContext.js
// UploadContext.js
import { createContext } from "react";

const UploadContext = createContext(null);

export default UploadContext;
